export interface BrandRef {
  id: number;
  name: string;
}

export interface MarketRef {
  id: number;
  name: string;
}

export interface FilterRef {
  type: string;
  filterId: number;
  filterOptions?: number[];
}

export interface PeriodRef {
  type: string;
  startDate?: string;
  endDate?: string;
}

export interface CurrentScreenContext {
  brands: BrandRef[];
  secondaryBrands: BrandRef[];
  markets: MarketRef[];
  module: string;
  metricKeys: Array<string | number>;
  groupKeys: Array<string | number>;
  responseKeys: Array<string | number>;
  segments: number[];
  filters: FilterRef[];
  audienceBase: string;
  viewMode: string;
  visualizationType: string;
  groupedBy: string;
  statTest: string;
  scoreType: string;
  intervalType: string;
  period: PeriodRef;
  postPeriod: PeriodRef;
}

export const DEFAULT_SCREEN_CONTEXT: CurrentScreenContext = {
  brands: [],
  secondaryBrands: [],
  markets: [],
  module: "",
  metricKeys: [],
  groupKeys: [],
  responseKeys: [],
  segments: [],
  filters: [],
  audienceBase: "GENPOP",
  viewMode: "POINT_IN_TIME",
  visualizationType: "BAR",
  groupedBy: "BRAND",
  statTest: "NONE",
  scoreType: "",
  intervalType: "",
  period: { type: "" },
  postPeriod: { type: "" },
};
